<template>
    <div>
        <div v-if="!loaded">Generating video preview. This may take a while. Check back later.</div>
        <div class="justify-content-center"  v-if="loaded">

            <a href="#" @click.prevent="modalTriggerOpenModal()" class="btn btn-primary btn-preview-video-asset"><i class="fa fa-play-circle"></i> <span>Preview</span></a>
            <modal v-show="modalTriggerValue" @close="modalTriggerCloseModal()" modalclass="modal-videofile" clickoutside="true">
                <div slot="header" class="d-flex justify-content-between full-width">
                    <div>
                        <h3 class="mb-0">{{episode}}</h3>
                        <p v-if="playerData.videoId && is_admin" class="mb-0">Brightcove ID: {{ playerData.videoId }}</p>
                    </div>
                    <i class="close-icon" @click="modalTriggerCloseModal()"></i>
                </div>
                <div class="content" slot="body">
                    <div :id="'vfo_player'+rando"></div>
                    {{ filename }}
                </div>
            </modal>
            <div class="small brightcove_id_abs" v-if="playerData.videoId && is_admin">Brightcove Id: {{ playerData.videoId }}</div>
        </div>
    </div>
</template>

<script>
import modal from './Modal.vue';
import brightcovePlayerLoader from '@brightcove/player-loader';

export default {
    name: "Videofile",
    props: {
        asset_id: String,
        episode: String,
        filename: String,
        is_admin: {
            type: Boolean,
            default: false,
        },
    },
    components: {modal},
    data() {
        return {
            player: '',
            modalTriggerValue: false,
            videoPlaying: false,
            loaded: false,
            myPlayer: null,
            playerId: null,
            // +++ Set the data for the player +++
            playerData: {
                accountId: "1483464688001",
                playerId: "default",
                videoId: this.asset_id
            },
            rando: this.asset_id
        }
    },
    created() {
        console.log('created asset_id ',this.asset_id);
    },
    mounted() {
        let app = this;
        app.playerId = 'vfo_player'+app.rando;
        // fetch the playback urls
        // console.log('mounted vfoid ',this.asset_id);
        $(window).resize(app.fitPlayerToWindow);
        app.loaded = true;
    },
    watch: {
        modalTrigger: function (val) {
            this.loadVids();
        }
    },
    methods : {
        modalTriggerOpenModal: function() {
            this.modalTriggerValue = true;
            this.loadVids();

        },
        modalTriggerCloseModal: function() {
            this.myPlayer.pause();
            this.modalTriggerValue = false;
        },
        loadVids: function() {
            let app = this;

            brightcovePlayerLoader({
                refNode: document.querySelector('#'+app.playerId),
                refNodeInsert: 'replace',
                accountId: app.playerData.accountId,
                playerId: app.playerData.playerId,
                embedId: 'default',
                videoId: app.asset_id
            })
                .then(function(success) {
                    // The player has been created!
                    app.myPlayer = success.ref;
                    console.log('success', success);
                    app.myPlayer.on('loadedmetadata',function() {
                        app.fitPlayerToWindow();
                    });

                })
                .catch(function(error) {
                    // Player creation failed!
                    console.log(error);
                });
        },
        fitPlayerToWindow: function() {
            let app = this;
            const videoPlayerElement = $('#'+app.playerId);
            if(videoPlayerElement.length) {
                const ratio = Math.min(1, ($(window).height() - 140) / videoPlayerElement.height());
                if (ratio === 1) {
                    videoPlayerElement.css('height', '100%');
                    videoPlayerElement.css('width', '100%');
                } else {
                    videoPlayerElement.css('height', videoPlayerElement.height() * ratio + 'px');
                    videoPlayerElement.css('width', videoPlayerElement.width() * ratio + 'px');
                }
            }
        }
    }
}
</script>
<style lang="scss">
.bmpui-ui-watermark {
    display:none;
}
.bmpui-ui-recommendation-overlay {

}
.modal-videofile .bitmovinplayer-container {
    margin: 0 auto !important;
}
.video-js {
    width:100%;
    height:650px;
}
</style>
